import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTruck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-truck-icon lucide-truck",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 18H9" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 18,
			r: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7,
			cy: 18,
			r: 2
		})
	]
});
export default SvgTruck;
